import { createAction } from 'redux-act';

export const initMarketplace = createAction<{ hashId: string; isDonation: boolean }>('MARKETPLACE/INIT_MARKETPLACE');
